module.exports = __webpack_public_path__ + "img/radio6.b01227a8.png";